import RenderTooltipMessage from "../renderTooltipMessage/renderTooltipMessage";

import { isEmpty } from "@/main/services/utils";

import * as S from "./styles";

interface IFileCommentProps {
	id: string;
	comment?: string;
}

function FileComment({ id, comment }: IFileCommentProps) {
	if (isEmpty(comment)) return null;

	return (
		<RenderTooltipMessage placement="top" tooltipMessage={comment}>
			<S.FileCommentText id={id}>{comment}</S.FileCommentText>
		</RenderTooltipMessage>
	);
}

export default FileComment;
